import { useEffect } from 'react';
import { X } from 'lucide-react';

/** Item 19: shown after a New Client / New Engagement request is submitted. */
export function SubmittedDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div role="dialog" aria-modal="true" className="relative w-full max-w-md rounded-lg bg-card p-6 shadow-xl">
        <button type="button" aria-label="Close" className="absolute right-3 top-3 rounded p-1 text-muted-foreground hover:text-foreground"
          onClick={onClose}>
          <X className="h-5 w-5" />
        </button>
        <div className="space-y-3 pr-6 text-sm font-semibold text-foreground">
          <p>
            Thank you for your submission. As appropriate, the Admin Team will update the following software systems
            per your request:
          </p>
          <ul className="ml-5 list-disc">
            <li>Maconomy</li>
            <li>CCH Engagement</li>
            <li>Axcess</li>
          </ul>
          <p>You will receive a confirmation email when your submission has been completed.</p>
        </div>
        <div className="mt-6 flex justify-end">
          <button type="button" className="btn-success" autoFocus onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
}
